export default "__VITE_ASSET__CwX6tBLD__"